import { Box, Typography, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ThermostatIcon from "@mui/icons-material/Thermostat";

const ACTemperature1Widget = ({ widget, onValueUpdate }) => {
  const [temperature, setTemperature] = useState(22.0);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setTemperature(Number(widget.items.$w1.value));
    }
  }, [widget]);

  const handleTemperatureChange = (delta) => {
    const newTemp = Number((temperature + delta).toFixed(1));
    setTemperature(newTemp);
    if (onValueUpdate) {
      onValueUpdate({
        ...widget?.items?.$w1,
        value: newTemp,
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        backgroundColor: "background.paper",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: 1,
          paddingLeft: 2,
        }}
      >
        <ThermostatIcon sx={{ color: "#FFB74D", fontSize: "1.2rem" }} />
        <Typography sx={{ fontSize: "0.9rem" }}>
          {temperature.toFixed(1)} °C
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#f5f5f5",
          padding: "4px",
          margin: "0 8px 8px 8px",
          borderRadius: 1,
        }}
      >
        <IconButton
          size="small"
          onClick={() => handleTemperatureChange(-0.5)}
          sx={{ color: "text.secondary" }}
        >
          <RemoveIcon fontSize="small" />
        </IconButton>

        <Typography sx={{ fontSize: "1rem", fontWeight: "medium" }}>
          {temperature.toFixed(1)} °C
        </Typography>

        <IconButton
          size="small"
          onClick={() => handleTemperatureChange(0.5)}
          sx={{ color: "text.secondary" }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ACTemperature1Widget;
